import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';

@Component({
  selector: 'app-classlist',
  templateUrl: './classlist.component.html',
  styleUrls: ['./classlist.component.css']
})
export class ClasslistComponent {
  @Input() lessons: any;
  @Input() admin: boolean;
  @Input() canViewLessons: boolean;
  constructor(private classmanager: ClassmanagementService, private toastr: ToastrService) { }

  getHTMLIDRef(id: string) {
    return `#collapse${id}`;
  }

  async movelessondown(e: Event, lessonid:number, lessontitle: string, moduleid:number)
  {
    e.stopPropagation();
    this.toastr.warning('Moving Lesson Down', lessontitle);
    this.lessons=await this.classmanager.movelessondown(lessonid,moduleid).toPromise();
    this.toastr.success('Moved Lesson Down', lessontitle);
  }

  async movelessonup(e: Event, lessonid:number, lessontitle: string, moduleid:number)
  {
    e.stopPropagation();
    this.toastr.warning('Moving Lesson Up', lessontitle);
    this.lessons=await this.classmanager.movelessonup(lessonid,moduleid).toPromise();
    this.toastr.success('Moved Lesson Up', lessontitle);
  }
}
